import {
    Component,
    OnInit,
    OnDestroy,
    AfterViewInit,
    Input
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Router } from '@angular/router';
declare var Hls: any;
declare const videojs: any;
import { MatDialog} from '@angular/material/dialog';
import { TipsFeedbackPopupComponent } from '../tips-feedback-popup/tips-feedback-popup.component';
import { AppService } from 'src/app/core/services/app.service';
@Component({
    selector: 'm3u8-video',
    templateUrl: './video.component.html',
    styleUrls: ['./vod.component.scss']
})

export class VideoJSComponent implements OnInit, AfterViewInit {

    @Input() videoUrl: any;
    @Input() start_live_diff: any;
    @Input() openFrom: any;

    private player: any;
    hlsPlayVideoSubscription: Subscription;
    isAutoPlayHLSVideo = false;

    // constructor initializes our declared vars
    constructor(
        private commanSubscribeService : CommanSubscribeService,
        public router: Router,
        private dialog: MatDialog,
        private appService:AppService
        ) {
        // this.player = false;
    }

    ngOnInit() {
        let aa = this.openFrom;
        this.hlsPlayVideoSubscription = this.commanSubscribeService.getPlayHLSVideo().subscribe(response => {
            if(response){
               this.player.play();
            } else {
               this.player.pause();
            }
            this.isAutoPlayHLSVideo = response;
       });
     }

    // use ngAfterViewInit to make sure we initialize the videojs element
    // after the component template itself has been rendered

    ngAfterViewInit() {
        this.player = document.getElementById('m3u8video');       

        if (Hls.isSupported()) {            
            var hls = new Hls();
            // bind them together
            hls.attachMedia(this.player);
            hls.on(Hls.Events.ERROR, (event, data) => {
              console.error('HLS error:', data.type, data.details, data);
            });
            hls.on(Hls.Events.MEDIA_ATTACHED, () => {
              //console.log("video and hls.js are now bound together !");
              hls.loadSource(this.videoUrl);
              hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
                //console.log("manifest loaded, found " + data.levels.length + " quality level");
                let promise = this.player.play();
                if (promise !== undefined) {
                    promise.then(_ => {
                        this.isAutoPlayHLSVideo = true;
                        this.commanSubscribeService.sendPlayHLSVideo(true);
                      // Autoplay started!
                       // console.log("auto play video HLSSSSSS");
                    }).catch(error => {
                        this.isAutoPlayHLSVideo = false;
                        this.commanSubscribeService.sendPlayHLSVideo(false);
                       // console.log("auto play video fail HLSSSSSS");
                    });
                }

              });
              this.player.play();
            });
            if(this.start_live_diff) {
                this.player.currentTime = this.start_live_diff;
            }   
        } else if (this.player.canPlayType('application/vnd.apple.mpegurl')) {
            this.player.src = this.videoUrl;
            this.player.addEventListener('loadedmetadata', () => {
                this.player.play();
            });
        }
    }

    videoEnded(){
        this.appService.videoEnded.next('videoEnded') //.next(data.value);
    }

    ngOnDestroy() {
        // this.player.dispose();
        if (this.hlsPlayVideoSubscription)
            this.hlsPlayVideoSubscription.unsubscribe();
        this.player = document.getElementById('m3u8video');  
        if(this.player) {
            this.player.pause();
        }
    }

}